import { createContext } from "react";

type OverallCoreValuesAssessmentQuestionDescriptionContextType = {
  averageScoreOfIndividualCoreValuesBasedQuestions?: string;
  scale?: number;
};

export const OverallCoreValuesAssessmentQuestionDescriptionContext =
  createContext<OverallCoreValuesAssessmentQuestionDescriptionContextType>({});
